// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2HhxS","col":"styles_col__2Mi_r"};